export default {
  "route": {
    "title": "Sistema de publicação de informações",
    "home": "Início",
    "terminal": "Terminal",
    "program": "Programa",
    "h5program": "Programa",
    "my": "Meu",
    "remote_control": "Controle remoto",
    "task_details": "Detalhes da tarefa",
    "add_task": "Adicionar tarefa",
    "program_list": "Lista de programas",
    "terminal_info": "Informações do terminal",
    "add_resolution": "Adicionar resolução",
    "add_program": "Adicionar programa",
    "material_management": "Gestão de materiais",
    "materialRecycleBin": "Lixeira de materiais",
    "create_program": "Criar programa",
    "login": "Entrar",
    "reset_password": "Redefinir senha",
    "change_password": "Alterar senha",
    "preview": "Pré-visualização"
  },
    recharge_center: {
      title: "Central de Recarga",
      tab_recharge: "Recarga",
      tab_order: "Pedidos",
      tab_invoice_record: "Registros",
      summary_total_devices: "Total de dispositivos",
      summary_expired_devices: "Dispositivos expirados",
      summary_expiring_30_days: "Expiram em 30 dias",
      select_plan: "Selecionar plano de recarga",
      plan_name_years: "Plano de {years} ano(s)",
      price_unit_per_device: "/dispositivo",
      plan_desc_valid_years: "Válido por {years} ano(s)",
      select_device: "Selecionar dispositivo",
      device_selection_stats: "Disponíveis: {total}, Selecionados: {selected}",
      search_device_name: "Buscar nome do dispositivo",
      all_devices: "Todos os dispositivos",
      expired_devices: "Dispositivos expirados",
      expiring_within_30_days: "Expiram em 30 dias",
      select_all: "Selecionar tudo",
      no_renewable_device: "Nenhum dispositivo renovável",
      pending_invoice_amount: "Valor pendente de fatura",
      product: "Produto",
      amount: "Valor",
      status: "Status",
      time: "Hora",
      order_detail: "Detalhes do pedido",
      request_invoice: "Solicitar fatura",
      no_order: "Sem pedidos",
      package_label: "Plano",
      unselected: "Não selecionado",
      total_label: "Total",
      recharge: "Recarregar",
      wechat_scan_pay: "Pagar via QR do WeChat",
      qr_expired_tip: "O QR code expirou. Feche e crie um novo pedido.",
      order_no: "Nº do pedido",
      remaining_time: "Tempo restante",
      copy_link: "Copiar link",
      paid: "Já paguei",
      detail_description: "Detalhes",
      invoice_title_info: "Informações do título",
      select_saved_invoice_title_optional: "Selecionar título salvo (opcional)",
      invoice_title: "Título da fatura",
      enter_or_select_invoice_title: "Insira ou selecione o título da fatura",
      title_type: "Tipo de título",
      invoice_type: "Tipo de fatura",
      tax_no: "Número fiscal",
      enter_tax_no: "Insira o número fiscal",
      phone: "Telefone",
      optional_placeholder: "Opcional",
      email: "E-mail",
      enter_email: "Insira o e-mail",
      fill_invoice_title: "Insira o título da fatura",
      select_title_type: "Selecione o tipo de título",
      select_invoice_type: "Selecione o tipo de fatura",
      enterprise_tax_no_required: "Título empresarial exige número fiscal",
      fill_email: "Insira o e-mail",
      invalid_email: "Formato de e-mail inválido",
      personal: "Pessoal",
      enterprise: "Empresa",
      ordinary_invoice: "Fatura comum",
      vat_invoice: "Fatura especial de IVA",
      loading_devices: "Carregando dispositivos...",
      get_plan_failed: "Falha ao carregar planos",
      select_plan_and_device: "Selecione um plano e dispositivos",
      device_count: "Dispositivos",
      confirm_create_payment_order: "Confirmar criação do pedido de pagamento?",
      confirm_recharge: "Confirmar recarga",
      submitting: "Enviando...",
      create_order_failed: "Falha ao criar pedido",
      payment_marked: "Pagamento marcado",
      invoice_available: "Faturável",
      invoiced: "Faturado",
      order_load_failed: "Falha ao carregar pedidos",
      invoice_submitted: "Solicitação de fatura enviada",
      filter_by_username: "Filtrar por nome de usuário",
      all: "Todos",
      pending_invoice: "Fatura pendente",
      voided: "Anulado",
      invoiced_amount: "Valor faturado",
      current_count: "Quantidade atual",
      billing_time: "Data da fatura",
      view: "Ver",
      download: "Baixar",
      no_invoice_record: "Nenhum registro de fatura",
      no_viewable_file: "Nenhum arquivo visualizável",
      no_downloadable_file: "Nenhum arquivo para baixar"
  },
    append_field: {
    "input_code": "Por favor, insira o código de verificação",
    "code_error": "Erro no código de verificação",
    "fill_code": "Por favor, insira o código de verificação",
    "dOut": "Rotação 3D",
    "dIn": "Rotação 3D",
    "dxiao": "Moldura 3D",
    "selectImage": "Por favor, selecione uma imagem",
    "onlySelectOneImage": "Só pode selecionar uma imagem",
    "imageFormatError": "Erro no formato da imagem",
    "cancel": "Cancelar",
    "selectedNumber": "Selecionado",
    "confirm": "Confirmar",
    "loadinga": "Carregando...",
    "loadingb": "Carregando",
    "uploading": "Carregando",
    "selectStartDates": "Selecione a data de início",
    "selectEndDates": "Selecione a data de término",
    "createTask": "Criar nova tarefa",
    "selectPrograms": "Selecionar programas",
    "createPrograms": "Nuevo",
    "editTask": "Editar tarefa",
    "fillTaskName": "Por favor, insira o nome",
    "selectTaskGroup": "Por favor, selecione o grupo de tarefas",
    "selectProgram": "Por favor, selecione o programa",
    "selected": "Selecionado",
    "programs": "programas",
    "selectDevice": "Por favor, selecione o dispositivo",
    "sendTaskSuccess": "Tarefa enviada com sucesso",
    "taskName": "Nome",
    "playMode": "Modo de reprodução",
    "replaceMode": "Substituição",
    "appendMode": "Adição",
    'apotpatterns': 'Interrupção',
    "dateRange": "Datas de reprodução",
    "timeRange": "Horas de reprodução",
    "taskPeriod": "Dias especificados",
    "mon": "Seg",
    "tue": "Ter",
    "wed": "Qua",
    "thu": "Qui",
    "fri": "Sex",
    "sat": "Sáb",
    "sun": "Dom",
    "back": "Voltar",
    "programList": "Lista de programas",
    "deviceList": "Lista",
    "enterContent": "Por favor, insira o conteúdo",
    "taskGroup": "Grupo de tarefas",
    "selectStartDate": "Selecione a data de início",
    "selectEndDate": "Selecione a data de término",
    "selectStartTime": "Selecione a hora de início",
    "selectEndTime": "Selecione a hora de término",
    "addTask": "Adicionar tarefa",
    "topLeft": "Superior esquerdo",
    "topCenter": "Centro superior",
    "topRight": "Superior direito",
    "leftCenter": "Centro esquerdo",
    "center": "Centro",
    "rightCenter": "Centro direito",
    "bottomLeft": "Inferior esquerdo",
    "bottomCenter": "Centro inferior",
    "bottomRight": "Inferior direito",
    "enterText": "Por favor, insira o texto",
    "fontColor": "Cor da fonte",
    "bgColor": "Cor de fundo",
    "scrollDirection": "Direção de rolagem",
    "scrollSpeed": "Velocidade de rolagem",
    "fontSize": "Tamanho da fonte",
    "alignment": "Alinhamento",
    "subtitle": "Legenda",
    "enterURL": "Por favor, insira a URL",
    "webPage": "Página web",
    "enterMediaURL": "Por favor, insira o endereço de streaming",
    "media": "Streaming",
    "selectVideo": "Por favor, selecione um vídeo",
    "unsupportedFormat": "Formato de arquivo não suportado.",
    "cancelAllSelections": "Cancele todas as seleções antes de fazer o upload de um novo arquivo",
    "fileName": "Nome do arquivo",
    "fileSize": "Tamanho do arquivo",
    "uploadProgress": "Progresso do upload",
    "cancelUpload": "Cancelar upload",
    "cancelAllUploads": "Cancelar todos os uploads",
    "leftToRights": "Esquerda",
    "rightToLefts": "Direita",
    "bottomToTops": "Cima",
    "static": "Estático",
    "slow": "Lento",
    "medium": "Médio",
    "fast": "Rápido",
    "colorValue": "Valor da cor",
    "defaultEffect": "Efeito padrão",
    "rightToLeft": "Direita",
    "leftToRight": "Esquerda",
    "topToBottom": "Baixo",
    "bottomToTop": "Cima",
    "accordionSqueeze": "Acordeão",
    "zoomInFade": "Zoom in",
    "zoomOutFade": "Zoom out",
    "depthOfField": "Profundidade",
    "leftRightRotate": "Rotação L/D",
    "upDownRotate": "Rotação C/B",
    "counterclockwiseRotate": "Anti-horário",
    "clockwiseRotate": "Horário",
    "upDownZoom": "Zoom V",
    "scaleFade": "Escala",
    "zoomInDisappearing": "Zoom in",
    "transparentFade": "Desvanecimento",
    "gradientScale": "Escala de gradiente",
    "deleteMaterial": "Excluir material",
    "confirmDeleteMaterial": "Confirmar exclusão deste material?",
    "unreviewed": "Não revisado",
    "normal2": "Normal",
    "violating": "Violando",
    "suspectedViolating": "Suspeita de violação",
    "delete": "Excluir",
    "selectMaterial": "Selecione o material",
    "deleteProgramGroup": "Excluir grupo de programa",
    "confirmDeleteGroup": "Confirmar exclusão deste grupo?",
    "add": "Adicionar",
    "toggle_effect": "Alternar efeito",
    "toggle_time": "Alternar tempo",
    "pub_toggle_time": "Alternância",
    "fullscreen": "Tela cheia",
    "normal": "Normal",
    "interactive": "Interativo",
    "main_screen": "Tela principal",
    "sub_screen": "Tela secundária",
    "dual_screen": "Tela dupla",
    "sync_task": "Sincronizar tarefa",
    "normal_mode": "Modo normal",
    "basic_info": "Informações básicas",
    "program_info": "Informações do programa",
    "task_name": "Nome",
    "task_type": "Tipo de tarefa",
    "pub_task": "Tarefa normal",
    "hu_task": "Tarefa interativa",
    "no_data": "Sem dados",
    "no_msg": "Sem informações",
    "program_name": "Nome",
    "program_resolution": "Resolução do programa",
    "program_type": "Tipo de programa",
    "screen_category": "Categoria de tela",
    "edit_program": "Editar programa",
    "edit": "Editar",
    "send": "Enviar",
    "create": "Criar grupo",
    "reload": "Recarregar",
    "name": "Nome",
    "create_task_z": "Criar grupo de tarefas",
    "ps_push_name": "Por favor, insira o nome do grupo",
    "device_list": "Lista de dispositivos",
    "delete_task_group": "Excluir grupo de tarefas",
    "confirm_delete_group": "Confirmar exclusão deste grupo?",
    "delete_success": "Exclusão bem-sucedida",
    "name_cannot_be_empty": "O nome não pode estar vazio",
    "character_length_limit": "O comprimento do caractere deve ser de até 10 caracteres",
    "create_task_success": "Criação de tarefa bem-sucedida",
    "create_task_failed": "Criação falhou",
    "confirm_delete_task": "Você tem certeza que deseja excluir a tarefa?",
    "task_details": "Detalhes da tarefa",
    "download_success": "Download bem-sucedido",
    "waiting_download": "Aguardando download",
    "downloading": "Baixando",
    "confirm_delete": "Você tem certeza que deseja excluir?",
    "confirm_delete_all": "Você tem certeza que deseja excluir tudo?",
    "confirm_delete_selected": "Você tem certeza que deseja excluir a seleção?",
    "no_data_to_clear": "Não há dados para limpar!",
    "refresh": "Atualizar",
    "clear_all": "Limpar tudo",
    "clear_completed": "Concluídos",
    "device_id": "ID",
    "task_size": "Tarefa",
    "speed": "Velocidade",
    "download_progress": "Progresso do download",
    "title": "Título",
    "volume": "Volume",
    "deleteP": "Excluir programa",
    "con_P": "Confirmar exclusão deste programa?",
    "clear": "Limpar",
    "download_status": "Status do download",
    "height_width_cannot_be_empty": "Altura/Largura não pode estar vazio",
    "add_success": "Adição bem-sucedida",
    "enter_number_between_300_to_8000": "Insira um número entre 300 e 8000",
    "width": "Largura",
    "enter_width": "Por favor, insira a largura",
    "height": "Altura",
    "enter_height": "Por favor, insira a altura",
    "confirm_leave_page": "Você tem certeza que deseja sair desta página?",
    "add_content_to_control": "Adicione conteúdo ao controle",
    "add_control": "Adicione controle",
    "save_success": "Salvar com sucesso",
    "save": "Salvar",
    "create_program": "Criar programa",
    "guess": "Você adivinha",
    "modify": "Modificar",
    "text": "Texto",
    "image": "Imagem",
    "background_image": "Imagem de fundo",
    "background_music": "Música de fundo",
    "replace": "Substituir",
    "use_this_template": "Usar este modelo",
    "apply_template": "Aplicar modelo",
    "enter_program_name": "Por favor, insira o nome do programa",
    "program_group": "Grupo de programas",
    "select_program_group": "Selecione o grupo de programas",
    "group_list": "Lista de grupos",
    "preview": "Pré-visualização",
    "my_apps": "Meus aplicativos",
    "template_center": "Centro de templates",
    "home": "Início",
    "source_of_visit": "Fonte da visita",
    "online": "Online",
    "terminal_status": "Status",
    "memory_status": "Status da memória",
    "material_recycle_bin": "Lixeira de materiais",
    "material_recycle_bin_tips": "Os materiais excluidos podem ser restaurados ou removidos permanentemente aqui.",
    "login": "Entrar",
    "sms_verification": "Verificação por SMS",
    "email_verification": "Verificação por e-mail",
    "log_in": "Fazer login",
    "enter_username": "Insira sua conta",
    "username_cannot_be_empty": "O nome de usuário não pode estar vazio",
    "password_cannot_be_empty": "A senha não pode estar vazia",
    "incorrect_phone_format_for_verification_code": "O formato do número de telefone para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "incorrect_email_format_for_verification_code": "O formato do e-mail para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "incorrect_phone_or_email_format_for_verification_code": "O formato do e-mail ou telefone para o código de verificação está incorreto. Entre em contato com o administrador para corrigir!",
    "reset_password": "Redefinir senha",
    "remember_password": "Lembrar senha",
    "register": "Registrar conta",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "Notificação sobre segurança da rede",
    "got_it": "Entendi",
    "please_authenticate_for_account_safety": "Para a segurança da sua conta, por favor, autentique-se",
    "enter_account": "Insira sua conta",
    "enter_password": "Insira sua senha",
    "verification_code": "Código de verificação",
    "none": "Nenhum",
    "personal_center": "Centro pessoal",
    "remote_control": "Controle remoto",
    "refresh_success": "Atualização bem-sucedida!",
    "logout": "Sair",
    "confirm_logout": "Tem certeza de que deseja sair?",
    "user_status": "Status do usuário",
    "customer_address": "Endereço do cliente",
    "account_period": "Período da conta",
    "device_control": "Controle remoto do dispositivo",
    "clear_cache": "Limpar cache",
    "exit": "Sair",
    "terminal": "Terminal",
    "program": "Programa",
    "material": "Material",
    "my": "Meu",
    "display_type": "Tipo de exibição",
    "proportion": "Proporção",
    "resolution": "Resolução",
    "screen_orientation": "Orientação da tela",
    "landscape": "Paisagem",
    "portrait": "Retrato",
    "add_resolution": "Adicionar resolução",
    "execute_formatting_when_focus_lost": "Executar formatação ao perder foco",
    "select_resolution": "Selecione a resolução",
    "resolution_list": "Lista de resoluções",
    "confirm_delete_program": "Tem certeza de que deseja excluir o programa?",
    "confirm_delete_this_program": "Tem certeza de que deseja excluir este programa?",
    "bound_tasks_exists_confirm_delete": "Existem tarefas vinculadas, tem certeza de que deseja excluir?",
    "prompt": "Dica",
    "delete_failed": "Falha ao excluir",
    "modification_time": "Hora de modificação",
    "resolution_": "Resolução",
    "associated_tasks": "Tarefas associadas",
    "bound_task": "Tarefa vinculada",
    "program_management": "Gestão de programas",
    "task": "Tarefa",
    "progress": "Progresso",
    "phone_number": "Número de telefone",
    "enter_phone_number": "Insira o número de telefone",
    "password": "Senha",
    "confirm_password": "Confirmar senha",
    "enter_password_again": "Insira a senha novamente",
    "company_name": "Nome da empresa",
    "enter_company_name": "Insira as informações da sua empresa",
    "address": "Endereço",
    "enter_address": "Insira o endereço de contato",
    "username_not_exist": "O nome de usuário não existe",
    "enter_new_password": "Insira uma nova senha",
    "enter_new_password_again": "Insira a nova senha novamente",
    "terminal_management": "Gerenciamento de terminal",
    "delete_group": "Excluir grupo",
    "pel_select_group": "Selecione um grupo",
    "enter_device_name": "Insira o nome do dispositivo",
    "delete_device": "Excluir dispositivo",
    "confirm_delete_device": "Confirmar exclusão deste dispositivo?",
    "terminal_information": "Informação do terminal",
    "qr_code_error": "Erro no código QR",
    "device_not_supported": "Dispositivo não suportado",
    "device_offline": "O dispositivo selecionado deve estar online para enviar comandos, por favor, selecione novamente!",
    "more": "Mais",
    "device_access": "Acesso ao dispositivo",
    "filter": "Filtrar",
    "all": "Todos",
    "offline": "Offline",
    "device_name": "Nome do dispositivo",
    "device_number": "Número do dispositivo",
    "device_group": "Grupo de dispositivos",
    "call_device_please_wait": "Chamando o dispositivo, por favor aguarde...",
    "create_terminal_group": "Criar novo grupo de dispositivos",
    "enter_search_keyword": "Insira a palavra-chave de busca",
    "bind_device": "Vincular dispositivo",
    "select_device_group": "Selecione um grupo de dispositivos",
    "authorized": "Autorizado",
    "unauthorized": "Não autorizado",
    "adjust_volume": "Ajustar volume",
    "reboot_device": "Reiniciar dispositivo",
    "wake_up": "Acordar",
    "sleep": "Suspender",
    "shutdown": "Desligar",
    "clean_up_timing_on_off": "Limpar temporizador",
    "clean_up_disk": "Limpar disco",
    "clean_up_task": "Limpar tarefa",
    "send_command": "Enviar comando",
    "confirm2": "Enviar?",
    "terminal_operation": "Operação do terminal",
    "bind_task": "Informações tarefa",
    "remote_command": "Comando remoto",
    "remote_monitor": "Monitoramento remoto",
    "adding_one_will_override_the_previous": "Somente um registro de tempo pode ser adicionado, o anterior será substituído",
    "screenshot_in_progress_please_wait": "Capturando tela, por favor aguarde",
    "schedule_on_off": "Programar ligar/desligar",
    "shutdown_time": "Desligamento",
    "startup_time": "Inicialização",
    "volume_setting": "Configuração de volume",
    "edit_device_name": "Editar nome do dispositivo",
    "please_select_time": "Por favor, selecione o horário",
    "device_not_online_please_retry": "O dispositivo não está online, por favor tente novamente",
    "sent_successfully": "Enviado com sucesso",
    "version": "V4.1.8",
    "texta": "Texto",
    "userName": "Conta",
    "email": "E-mail",
    "device_memory": "Memória do dispositivo",
    "device": "Dispositivo",
    "device_mac": "MAC do dispositivo",
    "screen_count": "Número de telas",
    "device_location": "Localização do dispositivo",
    "is_authorized": "Está autorizado?",
    "remark": "Observação",
    "device_ip": "IP do dispositivo",
    "system_version": "Versão do sistema",
    "playback_date": "Data de reprodução",
    "playback_period": "Período de reprodução",
    "retrieve_again": "Recuperar novamente",
    "please_enter_password": "Insira uma senha de mais de 8 caracteres que contenha números, letras e caracteres especiais [@#$%^&+=]!",
    "passwords_do_not_match": "As senhas inseridas não coincidem",
    "enter_new_password2": "Insira uma nova senha",
    "current_password_too_simple": "A senha atual é muito simples, por favor, altere sua senha o mais rápido possível, insira caracteres de mais de 8 dígitos que contenham números, letras e caracteres especiais [@#$%^&+=]",
    "creation_time": "Hora de criação",
    "login2": "Entrar",
    "welcome": "Bem-vindo ao login",
    "expired_login": "A autenticação expirou, por favor, faça login novamente.",
    "control": "Controle remoto",
    "add_task": "Adicionar tarefa",
    "program_list": "Lista de programas",
    "terminal_info": "Informação do terminal",
    "add_program": "Adicionar programa",
    "material_management": "Gerenciamento de materiais",
    "change_password": "Alterar senha",
    "enter_text_content": "Insira o conteúdo do texto",
    "hit_the_wall_on_back": "Ao voltar, há uma parede",
    "last_ceremony": "Última cerimônia",
    "already_top_level": "Já está no nível mais alto",
    "already_last_one": "Já é a última vez",
    "white_fox": "Raposa branca",
    "control_img": "Imagem",
    "control_video": "Vídeo",
    "control_streaming": "Streaming",
    "control_webPage": "Página da web",
    "control_subtitle": "Legendas",
    "control_HDMI": "HDMI",
    "control_addbackground": "Fundo",
    "Up": "Carregar",
    "onlyOne": "O controle só pode adicionar um",
    "clearBg": "Limpar fundo",
    "get_code": "Por favor, insira o código de verificação primeiro",
    "del_Null_Program": "Deseja limpar o programa vazio na lista?",
    "please_select_date": "Selecione pelo menos uma data",
    "last_size": "Espaço restante",
    "shutdown_tips": "Não é possível ligar remotamente após desligar",
    "last_size_upload": "Por favor, selecione novamente.",
    "end_date_earlier_than_start_date": "A data de término não pode ser anterior à data de início",
    "account_type": "Tipo de usuário",
    "user_type": "Usuário comum",
    "role_type": "Função",
    "super_administrator": "Superadministrador",
    "term_info_empty": "Informações do terminal estão vazias",
    "select_terminal_prompt": "Clique no botão de lista no canto superior direito para selecionar o terminal",
    "select": "Tudo",
    "data_empty": "Os dados estão vazios!",
    "content_review": "Revisão de conteúdo",
    "start_date": "Data de início",
    "end_date": "Data de término",
    "start_time": "Hora de início",
    "end_time": "Hora de término",
    "select_all": "Tudo",
    "select_group": "Selecionar grupo",
    "review": "Revisar",
    "material_type": "Tipo de material",
    "audio": "Áudio",
    "document": "Documento",
    "material_status": "Estado do material",
    "material_review": "Revisão do material",
    "current_selection_requires_review": "O material selecionado atualmente, precisa de revisão?",
    "invCode": "Código de convite",
    "tip_invitation_empty": "Por favor, insira o código de convite",
    "enter_userName": "Por favor, insira a conta do usuário",
    "enter_email": "Por favor, insira o e-mail",
    "file_less_38": "O arquivo deve ser menor que 38KB",
    "viewError": "Este arquivo não suporta visualização",
    "user": "Informações pessoais",
    "phone_number_too_short": "O comprimento do número de telefone deve ser maior que 9 dígitos",
    "oneImage": "A imagem de fundo já existe, se desejar reenvia-la, primeiro exclua-a",
    "del_title": "Confirmar exclusão",
    "del_message": "Tem certeza de que deseja excluir o controle?",
    "close": "Fechar",
    "exit_group_name": "Editar nome do grupo",
    "group_management": "Grupos",
    "language": "Trocar idioma",
    "mixture": "Mista",
    "date": "Data",
    "weeks": "Semanas",
    "time": "Hora",
    "new_password": "Nova senha",
    "enter_invCode": "Dica: solicite o código de convite ao administrador superior",
    "msg_password": "Dica: insira uma senha com mais de 8 dígitos que contenha números, letras e caracteres especiais [@#$%^&+=]!",
    "oneDoc": "O documento já existe, se desejar reenviá-lo, primeiro exclua-o",
    "Sunday": "Domingo",
    "Monday": "Segunda-feira",
    "Tuesday": "Terça-feira",
    "Wednesday": "Quarta-feira",
    "Thursday": "Quinta-feira",
    "Friday": "Sexta-feira",
    "Saturday": "Sábado",
    "input_error": "Todos os campos do formulário não podem estar vazios",
    video_tutorial:'Download de materiais',
      data_download:'Material',
    "view": "Assistir online",
    "selectDeviceOne": "Este comando só pode selecionar um dispositivo para consulta",
    "select_device_list": "Lista de dispositivos selecionados",
    "small_size": "Pequeno",
    "medium_size": "Médio",
    "large_size": "Grande",
    device_info:'Informações do dispositivo',
    "notification": "Notificação",
    "notif_title": "Conteúdo da Notificação",
    "notif_msg": "A partir de 5 de novembro de 2024, o Centro de Serviços ETV irá excluir materiais armazenados por mais de um ano. Por favor, esteja ciente e faça backup dos materiais importantes com antecedência. Agradecemos sua compreensão e cooperação.",
    reduce: 'Reduzir',
    bound_material: 'Material Vinculado',
    tip_material: 'O material do programa vinculado não pode ser excluído, por favor, desvincule o material primeiro.',
    boundpo: 'Programa Vinculado',
    bind_progron: 'Este material está vinculado a um programa e não pode ser excluído.',
    index: 'Índice',
    source: 'Fonte',
    getUploadSet_tip: 'Falha ao obter a desativação do upload de material.',
    getUploadstartTime_tip: 'O upload de materiais está proibido no momento. Por favor, faça o upload em horários não proibidos.',
    getUploadendTim: 'Upload de material desativado',
    "download": "Baixar",
    program_review: 'Revisão do programa',
    pass: 'Passar',
    not_passed_or_not_reviewed: 'Não aprovado ou não revisado',
    play_mode: 'Modo de reprodução',
    review_status: 'Status da revisão',
    reject: 'Rejeitar',
    review_content: 'Conteúdo da revisão',
    enter_review_content: 'Por favor, insira o conteúdo da revisão',
    device_quantity: "Quantidade de dispositivos",
    noMore: 'Não há mais',
    nameLengthLimit: 'Por favor, limite o comprimento do nome a 50 caracteres',
    "customer_title": "Consulta de conta",
    "authorized_devices": "Dispositivos autorizados",
    "enable": "Ativar",
    "disable": "Desativar",
    "expired": "Conta expirada",
    "valid_date": "Data válida",
    "valid_date_placeholder": "Insira a data válida",
    "capacity_rule": "A capacidade do servidor deve ser múltipla de 100",
    "capacity_label": "Capacidade do servidor (MB)",
    "download_speed": "Limite de velocidade de download",
    "submit_btn": "Enviar",
    "sub_accounts":"Apenas permite modificar subcontas",
    plan_mode: 'Modo de Planejamento',
    default_mode: 'Modo Padrão',
    "help": "Ajuda",
    "network_mode": "Distribuição em rede",
    "phone_mode": "Modo telefone",
    "standalone_mode": "Modo autônomo",
    "apk_download": "Baixar APK",
    "android": "Android",
    "ios": "iOS",
    "app_name": "ETV-H5 Assistente de Publicação de Informações",
    "info_publish": "Publicação de Informações",
    "upload_material": "Carregar Materiais",
    "customer_type": "Cliente de nível {level}",
    "network_import": "Distribuição em rede",
    "mobile_mode": "Modo móvel",
    "network_connection": "I. Conexão de rede",
    "network_methods": "Existem dois métodos de conexão de rede:",
    "network_method_1": "(1) Configurações → Rede e Internet → WLAN → Conectar à rede → Após conectar, abrir o ETV → O ícone de rede fica branco, conexão bem-sucedida.",
    "network_method_2": "(2) Abrir o ETV → Clique com o botão direito → Configurações do software → Selecionar distribuição em rede e Avançar → Configurações de propriedades → Configurações de WiFi → Ir para a tela de conexão WiFi e conectar → Voltar à tela anterior → Sair e retornar à tela principal do ETV → O ícone de rede fica branco, conexão bem-sucedida.",
    "account_registration": "II. Registro de conta",
    "registration_methods": "Existem dois métodos de registro:",
    "registration_method_1": "(1) Atribuição pelo superior: superior faz login → Gestão de clientes → Adicionar cliente → Preencher informações e confirmar → Criado com sucesso, a conta aparece na lista de clientes.",
    "registration_method_2": "(2) Registro livre: tela de login do servidor backend → Registrar conta → Preencher as informações e enviar → Registro bem-sucedido.",
    "invitation_code_source": "Origem do código de convite: superior faz login → Configuração do sistema → Gestão de códigos de convite → Adicionar código de convite.",
    "device_connection": "III. Conexão do dispositivo",
    "device_connection_steps": "Abrir o ETV → Clique com o botão direito → Configurações do software → Selecionar distribuição em rede e Avançar → Informar endereço do servidor (backend), porta de controle (padrão 8899), usuário (atribuído ou registrado) → Conectar → Após conectar, o dispositivo mostra conectado e a lista do backend exibe as informações do dispositivo.",
    "connect_terminal": "I. Conectar dispositivo terminal",
    "mobile_mode_tip": "(Mantenha o celular e o dispositivo na mesma rede local)",
    "scan_qr_wifi": "1. Conecte o celular ao hotspot do dispositivo ou à mesma rede WIFI/LAN do dispositivo.",
    "scan_qr_code": "2. Escanear (canto superior esquerdo): escaneie o QR do terminal para conectar o dispositivo.",
    "device_List": "3. Lista de dispositivos (canto superior direito): mostra todos os dispositivos na LAN; selecione o dispositivo.",
    "remote_Command": "II. Comando remoto",
    "send_Command": "Envie comandos ao dispositivo terminal e ele responderá de acordo.",
    "quick_send_program": "III. Envio rápido de programa",
    "quick_send_steps": "Enviar comando de exibição rápida → Obter materiais locais (imagens, vídeos, documentos), selecionar e confirmar → Definir o tempo de reprodução e confirmar → Programa enviado com sucesso.",
    "program_creation": "IV. Criação de programa",
    "new_program": "1. Novo programa: insira um nome com pelo menos 2 caracteres (pode ser gerado automaticamente pela hora de criação) e selecione orientação e tipo de exibição. Após criar, você será direcionado para a tela de edição.",
    "program_editing": "2. Edição do programa: selecione o modo de reprodução (substituir, inserir, adicionar). Clique em “<img src='/static/images/help/icon.png' alt='' />” para adicionar controles (imagem, vídeo, reprodução mista, documentos etc.) e ajuste tamanho/posição. Clique em “<img src='/static/images/help/icon_2.png' alt='' />” para adicionar materiais e configure as propriedades abaixo.",
    "program_sending": "V. Envio de programa",
    "send_program_steps": "Criar o programa → Clicar em Enviar → Selecionar dispositivos → Confirmar → Exibir progresso do download → Ao 100%, exibir concluído → O dispositivo reproduz o programa enviado.",
    "simple_mode_title": "I. Modo simples (padrão)",
    "simple_mode_description": "Este modo é o método de importação padrão no modo autônomo. Basta colocar imagens/vídeos na raiz do USB e inserir o USB para importar.",
    "simple_mode_note": "(PS: Suporta apenas importação de imagens e vídeos; equivale a um plugin de reprodução mista. Para outros cenários, use o segundo método do modo autônomo.)",
    "regular_mode_title": "II. Modo regular",
    "regular_mode_description": "Marque “Modo autônomo” e clique em Avançar para entrar na tela do modo autônomo (como mostrado abaixo).",
    "regular_mode_steps": "1. Clique em Layout da tela principal para configurar a tela principal<br>2. Clique em Layout da tela secundária para configurar a tela secundária",
    "step_one": "Passo 1:",
    "step_one_description": "Insira o USB, crie uma pasta chamada “etv-media” na raiz e crie a pasta “main” dentro. Para tarefas de tela dupla, crie a pasta “double” dentro de etv-media.",
    "step_two": "Passo 2:",
    "step_two_description": "De acordo com o layout da tela principal/secundária, crie as pastas 1/2/3/4 correspondentes dentro de main ou double.",
    "step_three": "Passo 3:",
    "step_three_description": "Copie os arquivos de imagem/vídeo do layout correspondente para as pastas 1/2/3/4 dentro de main/double.",
    "step_four": "Passo 4:",
    "step_four_description": "Suporta reprodução de documentos PDF em tela cheia; apenas um é permitido.",
    "step_five": "Passo 5:",
    "step_five_description": "Coloque o áudio no diretório MAIN/DOUBLE. e o sistema fará a reprodução em loop automaticamente.",
    "play_order_title": "Ordem de reprodução:",
    "play_order_description": "1: Prioridade para arquivos nomeados com números, em ordem crescente<br>2: Em seguida, arquivos nomeados com letras, de A a Z<br>3: Por fim, arquivos nomeados com caracteres chineses, pela ordem alfabética da primeira letra",
    "document_playback_note": "Sobre a reprodução de documentos (ativada por padrão): nas placas 3128 e M11 o interruptor de exibição de documentos vem desativado por padrão (para economizar desempenho) e deve ser ativado manualmente.",
    "recycle_search_placeholder": "Pesquisar nome do material",
    "recycle_type_all": "Todos os tipos",
    "recycle_restore_selected": "Restaurar selecionados",
    "recycle_clear_selected": "Excluir selecionados",
    "recycle_restore_all": "Restaurar tudo",
    "recycle_clear_all": "Esvaziar lixeira",
    "recycle_select_first": "Selecione os materiais primeiro",
    "recycle_restore_all_tip": "Todos os materiais da lixeira serão restaurados para a pasta selecionada abaixo. Continuar?",
    "recycle_clear_tip": "Os itens selecionados serão excluídos permanentemente e não poderão ser recuperados. Continuar?",
    "recycle_clear_all_tip": "A lixeira será esvaziada e os materiais serão excluídos permanentemente, sem possibilidade de recuperação. Continuar?",
    "recycle_load_fail": "Falha ao carregar",
    "recycle_btn_restore": "Restaurar",
    "recycle_summary_total": "Total {n} itens",
    "recycle_summary_size": "Total {s}",
    "recycle_summary_checked": "Selecionados {n}",
    "recycle_remain_auto_clear": "Restam {n} dias",
    "recycle_days_unit": "dias",
    "recycle_switch_off_notice": "Observação: Ao desativar a lixeira, os materiais excluídos serão removidos permanentemente.",
    "recycle_restore_target_folder": "Restaurar na pasta",
    "recycle_folder_pick_title": "Escolher pasta de restauração",
    "recycle_folder_select_this": "Esta pasta",
    "recycle_folder_tap_select": "Selecione uma pasta",
    "recycle_folder_invalid": "Pasta inválida",
    "recycle_folder_load_fail": "Falha ao carregar pastas",
    "recycle_folder_empty": "Sem pastas",
    "recycle_folder_pick_first": "Selecione uma pasta de restauração",
    "wx_config_incomplete": "Parâmetros de configuração do WeChat incompletos",
    "wx_missing_appid": "Falta appId na configuração do WeChat",
    "wx_jssdk_not_loaded": "JS-SDK do WeChat não carregado, atualize a página e tente novamente",
    "wx_version_not_support_scan": "Versão atual do WeChat não suporta função de escaneamento, atualize o WeChat",
    "wx_signature_failed": "Falha na verificação de assinatura do WeChat, verifique o algoritmo de assinatura e URL no backend",
    "wx_domain_not_config": "Domínio atual não configurado na Plataforma Oficial do WeChat, configure o domínio seguro da interface JS",
    "wx_config_failed": "Falha na configuração do WeChat",
    "wx_scan_init_failed": "Falha ao inicializar a função de escaneamento do WeChat",
    "browser_not_support_camera": "Seu navegador não suporta função de câmera",
    "scan_content_unrecognized": "Conteúdo escaneado não reconhecido, tente novamente!",
    "scan_lib_load_failed": "Falha ao carregar biblioteca de escaneamento, atualize a página e tente novamente",
    "wx_scan_not_ready": "Função de escaneamento do WeChat não pronta, inicializando...",
    "wx_scan_permission_denied": "Permissão de escaneamento do WeChat negada, verifique as configurações do WeChat ou atualize a página",
    "scan_connect": "Escanear para conectar",
    "confirm_connect_device": "Confirmar dispositivo de conexão",
    "confirm_connect_device_msg": "Conectar com {deviceName}?",
    "data_lost_rescan": "Dados perdidos, escaneie novamente",
    "connect_failed_retry": "Falha na conexão, tente novamente",
    "qrcode_placeholder": "Por favor, coloque o código QR dentro da moldura",
    "camera_unauthorized": "Acesso à câmera não autorizado",
    "camera_not_found": "Dispositivo de câmera não encontrado",
    "camera_select_failed": "Não é possível selecionar o dispositivo de câmera",
    "camera_start_failed": "Falha ao iniciar a câmera, clique para tentar novamente",
    "camera_permission_requesting": "Solicitando permissão da câmera",
    "camera_click_to_start": "Clique na tela para iniciar a câmera",
    "camera_permission_denied": "Permita o acesso à câmera, clique para tentar novamente",
    "camera_device_not_found": "Dispositivo de câmera não encontrado",
    "camera_init_failed": "Falha na inicialização da câmera, clique para tentar novamente",
    "scanner_not_initialized": "Scanner de código QR não inicializado",
    "scan_start_failed": "Falha ao iniciar a varredura de código QR",
    "qrcode_format_error": "Formato de dados do código QR incorreto",
    "qrcode_verify_success": "Verificação do código QR bem-sucedida",
    "qrcode_verify_failed": "Falha na verificação do código QR",
    "process_failed": "Falha no processamento",
    "camera_not_found_current": "Não é possível encontrar a câmera atual",
    "camera_switch_failed": "Não é possível alternar para outra câmera",
    "camera_no_alternatives": "Nenhuma câmera alternativa detectada",
    "scan_QR_code": "Escanear",
    "img_size": "O tamanho do pixel da imagem está anormal, verifique e faça o upload novamente.",
    "file_size_exceed_skip":'O tamanho do arquivo não pode exceder',
    "processing": "Processando",
    "failed": "Falhou",
    "no_menu_permissions_contact_admin": "Sem permissões de menu, entre em contato com o administrador",
    "superior_name": "Nome do Superior",
  },
  vanDialog: {
    confirm: 'Confirmar',
    cancel: 'Cancelar'
  },
  vanPicker: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  vanDatetimePicker: {
    title: 'Selecione a data',
  },
}
